<template>
  <asc-page-loading-indicator
    :loading="isAnserToolLoading && !apiPageFailure.length"
  >
    <v-container fluid class="asc-feature-details-container pa-4">
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <template v-if="isAnserToolPageActive">
            <v-container fluid class="px-0">
              <v-row justify="space-between" no-gutters align="center">
                <v-col>
                  <asc-page-title :title="getPageTitle" />
                </v-col>
                <v-col cols="2" class="text-right">
                  <asc-accent-button
                    primary
                    button-text="Add Custom Analytic"
                    :on-click="handleAddCustomAlertClick"
                  />
                </v-col>
              </v-row>
            </v-container>
            <asc-anser-signature-template :plotly-data="plotlyTokens" />
          </template>
        </v-col>
      </v-row>
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscPageLoadingIndicator from '../../../molecules/AscPageLoadingIndicator.vue'
import AscAnserSignatureTemplate from '../../../templates/AscAnserSignatureTemplate.vue'
import AscAccentButton from '../../../atoms/AscAccentButton.vue'
import AscPageTitle from '../../../atoms/AscPageTitle.vue'

import AppFeatureFlags from '@/utilities/appFeatureFlags'
import { ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID } from '@/utilities/appConsts'

import { mapState, mapGetters, mapActions } from 'vuex'
import {
  ANSER_TOOL_CONSTS as ATC,
  LOOKUP_CONSTS as LC,
  PLOTLY_CONSTS as PLYC,
} from '@/stores/consts'

export default {
  name: 'AscFeatureDetailsContainer',

  components: {
    AscPageTitle,
    AscAccentButton,
    AscPageLoadingIndicator,
    AscAnserSignatureTemplate,
  },

  data() {
    return {
      isSignaturesLoading: false,
      airline: this.$route.query.airline,
      platform: this.$route.query.platform,
      last_updated: this.$route.query.last_updated,
      feature: this.$route.query.feature,
      component: this.$route.query.component,
      occurence: this.$route.query.occurence,
      airlineId: this.$route.query.airlineId,
      platformId: this.$route.query.masterModelId,
      featureText: this.$route.query.featureText,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(LC.NAMESPACE, ['aircraftsLoading', 'masterModelsLoading']),
    ...mapGetters(ATC.NAMESPACE, ['mappedGFUserAirlinesWithMasterModels']),
    ...mapState(PLYC.NAMESPACE, ['plotlyTokens']),

    isAnserToolPageActive() {
      return AppFeatureFlags.getAnserToolPage()
    },

    isAnserToolLoading() {
      return (
        this.aircraftsLoading ||
        this.masterModelsLoading ||
        this.isSignaturesLoading
      )
    },

    getPageTitle() {
      return `${this.featureText} CORRELATED TO THE ${this.component}`
    },

    getMappedUserAirlines() {
      return this.mappedGFUserAirlinesWithMasterModels
    },
  },

  async mounted() {
    this.isSignaturesLoading = true
    await this[PLYC.GET_PLOTLY_TOKEN]({
      data: {
        airline: this.airline,
        platform: this.platform,
        last_updated: this.last_updated,
        feature: this.feature,
        component: this.component,
        occurence: this.occurence,
      },
      type: 'ANSER',
    })
    this.isSignaturesLoading = false
  },

  methods: {
    ...mapActions(PLYC.NAMESPACE, [PLYC.GET_PLOTLY_TOKEN]),

    handleAddCustomAlertClick() {
      //Full Flight Advanced Custom Alert Set Criteria Page with Airline and Platform populated
      if (this.airlineId && this.platformId) {
        this.$router.push({
          name: 'Custom Analytic',
          params: {
            alertType: 'advanced-fullflight',
            buildData: {
              airline: this.$route.query.airlineDisplayName,
              platform: this.platform,
              platformId: Number(this.platformId),
              reportType: null,
              airlineId: Number(this.airlineId),
              reportNumberId: null,
              customAlertTypeId: ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID,
            },
          },
        })
      }
    },
  },
}
</script>
